import {
  HOME_SCREEN_ADD_TILES,
  HOME_SCREEN_GET_TILES,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const getHomeScreenTiles = () => {
  const requestURL = HOME_SCREEN_GET_TILES;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const addHomeScreenTiles = (tileList) => {
  const requestURL = HOME_SCREEN_ADD_TILES;
  let obj = {tile_list: tileList || []};

  const reqParams = {
    method: methodType.POST,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
